import React, { Component } from 'react'

import Controls from '../common/controls'
import AriaMessage from '../common/ariaMessage'

class ScreenerEligible extends Component {
  constructor(props) {
    super(props)
    this.next = this._next.bind(this)
  }

  _next() {
    return this.props.next(this.props.match.path)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="screener-wrapper" id="screener_eligible">
        <AriaMessage message="Navigated to page You Are Eligible" />
        <div className="container flex">
          <h3 className="screener-label">You are eligible for the Newtopia Program.</h3>
          <h3 className="screener-label">Take the next step to a healthier you.</h3>
          <Controls className="screener-button" buttonClassName="register-now" nextLabel="REGISTER NOW" next={this.next} />
        </div>
      </div>
    )
  }
}

export default ScreenerEligible